import { useState } from 'react';
import PatientAgendaView from './Views/PatientAgendaView';
import PatientAgendaWithPatientView from './Views/PatientAgendaWithPatientView';
import CreatePatientView from './Views/CreatePatientView';
import { EAgendaViews } from '../RecipeEnums';
import { PatientRecordDTO, Professional } from '../../../interface/interface';

export default function PatientAgenda(params: { setActiveView: (av: any) => void, subActiveView:number | null, setSubActiveView: (av: number|null) => void, prevActiveView:number | null, setPrevActiveView: (pav: number|null) => void, prevSubActiveView:number | null, setPrevSubActiveView: (pav: number|null) => void, selectedPatient: PatientRecordDTO | null, setSelectedPatient: (patient: PatientRecordDTO|null) => void, professional: Professional }) {
    const { setActiveView, subActiveView, setSubActiveView, prevActiveView, setPrevActiveView, prevSubActiveView, setPrevSubActiveView, professional, selectedPatient, setSelectedPatient } = params;
    const [activeAgendaView, setActiveAgendaView] = useState<number>(subActiveView && subActiveView !== 0? subActiveView : EAgendaViews.PATIENTAGENDAVIEW);

    const handleSelectPatient = (patient:PatientRecordDTO) => {
        setSelectedPatient(patient);
        setActiveAgendaView(EAgendaViews.PATIENTAGENDAWITHPATIENTVIEW);
    };

    const handleBackToPatientAgendaView = () => {
        //TODO revisar
        // @ts-ignore
        setSelectedPatient(null);
        setActiveAgendaView(EAgendaViews.PATIENTAGENDAVIEW);
    };

    const handleCreatePatient = () => {
        setPrevSubActiveView(EAgendaViews.PATIENTAGENDAVIEW)
        setActiveAgendaView(EAgendaViews.CREATEPATIENTVIEW);
    };

    const handleEditPatient = (patient: PatientRecordDTO|null) => {
        setSelectedPatient(patient);
        setPrevSubActiveView(EAgendaViews.PATIENTAGENDAVIEW)
        setActiveAgendaView(EAgendaViews.CREATEPATIENTVIEW);
    };

    const handleBackToPatientAgendaWithPatientView = () => {
        setActiveAgendaView(EAgendaViews.PATIENTAGENDAWITHPATIENTVIEW);
    };

    const renderAgendaView = () => {
        if (activeAgendaView === EAgendaViews.PATIENTAGENDAVIEW) {
            return <PatientAgendaView setSelectedPatient={handleSelectPatient} onCreatePatient={handleCreatePatient} />;
        } else if (activeAgendaView === EAgendaViews.PATIENTAGENDAWITHPATIENTVIEW) {
            return <PatientAgendaWithPatientView setActiveView={setActiveView} setSubActiveView={setSubActiveView} setPrevActiveView={setPrevActiveView} setPrevSubActiveView={setPrevSubActiveView} professional={professional} selectedPatient={selectedPatient} onBack={handleBackToPatientAgendaView} onEditPatient={handleEditPatient}/>;
        } else {
            return <CreatePatientView selectedPatient={selectedPatient} setSelectedPatient={setSelectedPatient} onBack={handleBackToPatientAgendaView} onBackFromEdit={handleBackToPatientAgendaWithPatientView} setActiveView={setActiveView} subActiveView={subActiveView} setSubActiveView={setSubActiveView} prevActiveView={prevActiveView} setPrevActiveView={setPrevActiveView} prevSubActiveView={prevSubActiveView} setPrevSubActiveView={setPrevSubActiveView}/>;
        }
    };

    return (
        <div>
            {renderAgendaView()}
        </div>
    );
}
